import { GlobalState } from '../global.model';

export const initialState: GlobalState = {
    organisation: {},
    navigation: {},
    organisations: [],
    serviceCategories: [],
    serviceStatuses: [],
    services: [],
    collections: [],
    access: [],
    areas: [],
};
